module.exports = __webpack_public_path__ + "static/media/pencils.bce648cb.jpg";